import { Injectable } from '@angular/core';
import { Config } from '@model/config';

@Injectable({
    providedIn: 'root'
})
export class ConfigsStorage {
    config: Config;

    constructor() { }

    isDssSuiteEnable(): boolean {
        return this.config.DSS_SUITE_ENABLE == '1';
    }
}
